const content_dir = {
  // 隠しroot
  '/': {
    up_dir_name: '/',
    list: [
      {
        name: 'CalorieMate',
        type: 'dir',
        dir_name: '/CalorieMate',
        hidden: false,
      },
      {
        name: '.Secret',
        type: 'dir',
        dir_name: '/.Secret',
        hidden: true,
      },
    ],
  },
  '/CalorieMate': {
    up_dir_name: '/',
    list: [
      {
        name: 'BLOCK',
        type: 'dir',
        dir_name: '/CalorieMate/BLOCK',
        hidden: false,
      },
      {
        name: 'JELLY',
        type: 'dir',
        dir_name: '/CalorieMate/JELLY',
        hidden: false,
      },
      {
        name: 'LIQUID',
        type: 'dir',
        dir_name: '/CalorieMate/LIQUID',
        hidden: false,
      },
    ],
  },
  '/.Secret': {
    up_dir_name: '/',
    list: [
      {
        name: 'secret_command.txt',
        type: 'file',
        ext: 'text',
        cid: 'secret_txt_01',
        is_share_content: false,
        hidden: false,
      },
    ],
  },
  '/CalorieMate/BLOCK': {
    up_dir_name: '/CalorieMate',
    list: [
      {
        name: 'BLOCK.link',
        type: 'file',
        ext: 'link',
        cid: 'block_link_01',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'BLOCK_nutrition.txt',
        type: 'file',
        ext: 'text',
        cid: 'block_txt_01',
        is_share_content: false,
        hidden: false,
      },
      {
        name: '.eyes.txt',
        type: 'file',
        ext: 'text',
        cid: 'block_txt_02',
        is_share_content: false,
        hidden: true,
      },
    ],
  },
  '/CalorieMate/JELLY': {
    up_dir_name: '/CalorieMate',
    list: [
      {
        name: 'JELLY.link',
        type: 'file',
        ext: 'link',
        cid: 'jelly_link_01',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'JELLY_nutrition.txt',
        type: 'file',
        ext: 'text',
        cid: 'jelly_txt_01',
        is_share_content: false,
        hidden: false,
      },
    ],
  },
  // デフォルトHOME
  '/CalorieMate/LIQUID': {
    up_dir_name: '/CalorieMate',
    list: [
      {
        name: 'about',
        type: 'dir',
        dir_name: '/CalorieMate/LIQUID/about',
        hidden: false,
      },
      {
        name: 'articles',
        type: 'dir',
        dir_name: '/CalorieMate/LIQUID/articles',
        hidden: false,
      },
      {
        name: 'messages',
        type: 'dir',
        dir_name: '/CalorieMate/LIQUID/messages',
        hidden: false,
      },
      {
        name: 'product',
        type: 'dir',
        dir_name: '/CalorieMate/LIQUID/product',
        hidden: false,
      },
      {
        name: '.Quine',
        type: 'dir',
        dir_name: '/CalorieMate/LIQUID/.Quine',
        hidden: true,
      },
    ],
  },
  '/CalorieMate/LIQUID/about': {
    up_dir_name: '/CalorieMate/LIQUID',
    list: [
      {
        name: 'about.txt',
        type: 'file',
        ext: 'text',
        cid: 'about_txt_01',
        is_share_content: false,
        hidden: false,
      },
      // {
      //   name : 'logo.png',
      //   type : 'file',
      //   ext : 'image',
      //   cid : 'about_img_01',
      //   hidden : false
      // },
    ],
  },
  '/CalorieMate/LIQUID/articles': {
    up_dir_name: '/CalorieMate/LIQUID',
    list: [
      {
        name: 'article01.link',
        type: 'file',
        ext: 'link',
        cid: 'article_link_01',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'article02_AD.link',
        type: 'file',
        ext: 'link',
        cid: 'article_link_02',
        is_share_content: false,
        hidden: false,
      },
    ],
  },
  '/CalorieMate/LIQUID/messages': {
    up_dir_name: '/CalorieMate/LIQUID',
    list: [
      {
        name: 'readme.md',
        type: 'file',
        ext: 'text',
        cid: 'message_readme_01',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'matz.txt',
        type: 'file',
        ext: 'text',
        cid: 'message_matz_01',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'msg01.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_01',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg02.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_02',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg03.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_03',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg04.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_04',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg05.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_05',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg06.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_06',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg07.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_07',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg08.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_08',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg09.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_09',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg10.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_10',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg11.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_11',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg12.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_12',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg13.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_13',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg14.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_14',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg15.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_15',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg16.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_16',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg17.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_17',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg18.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_18',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg19.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_19',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg20.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_20',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg21.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_21',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg22.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_22',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg23.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_23',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg24.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_24',
        is_share_content: true,
        hidden: false,
      },
      {
        name: 'msg25.md',
        type: 'file',
        ext: 'text',
        cid: 'message_txt_25',
        is_share_content: true,
        hidden: false,
      },
    ],
  },
  '/CalorieMate/LIQUID/product': {
    up_dir_name: '/CalorieMate/LIQUID',
    list: [
      {
        name: 'overview.txt',
        type: 'file',
        ext: 'text',
        cid: 'product_txt_01',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'composition.txt',
        type: 'file',
        ext: 'text',
        cid: 'product_txt_02',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'LIQUID.link',
        type: 'file',
        ext: 'link',
        cid: 'product_link_01',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'shop1_otsuka.link',
        type: 'file',
        ext: 'link',
        cid: 'product_link_02',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'shop2_amazon.link',
        type: 'file',
        ext: 'link',
        cid: 'product_link_03',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'feature01.png',
        type: 'file',
        ext: 'image',
        cid: 'product_img_01',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'feature02.png',
        type: 'file',
        ext: 'image',
        cid: 'product_img_02',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'feature03.png',
        type: 'file',
        ext: 'image',
        cid: 'product_img_03',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'feature04.png',
        type: 'file',
        ext: 'image',
        cid: 'product_img_04',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'feature05.png',
        type: 'file',
        ext: 'image',
        cid: 'product_img_05',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'feature06.png',
        type: 'file',
        ext: 'image',
        cid: 'product_img_06',
        is_share_content: false,
        hidden: false,
      },
    ],
  },
  '/CalorieMate/LIQUID/.Quine': {
    up_dir_name: '/CalorieMate/LIQUID',
    list: [
      {
        name: 'readme.md',
        type: 'file',
        ext: 'text',
        cid: 'quine_readme_01',
        is_share_content: false,
        hidden: false,
      },
      {
        name: 'CML_quine.rb',
        type: 'file',
        ext: 'ruby',
        cid: 'quine_ruby_01',
        is_share_content: false,
        hidden: false,
      },
    ],
  },
}
export default content_dir
